import React from 'react';
import PublicLayout from '@/components/PublicLayout';
import SEO from '@/components/SEO';
import { Search, ClipboardList, Rocket, Shield, Zap, Users } from 'lucide-react';

const AboutUsPage = () => (
  <PublicLayout>
    <SEO title="About Us" description="EdAssist is India's premium education job portal connecting schools and institutions with qualified educators. Learn about our mission and vision." path="/about" />
    <div data-testid="about-us-page">
      {/* Hero */}
      <section className="bg-gradient-to-br from-indigo-600 via-indigo-700 to-slate-900 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl lg:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit' }}>Empowering Education Through the Right Talent</h1>
          <p className="text-lg text-indigo-100 max-w-2xl mx-auto">At EdAssist, we believe that educators are the foundation of a better tomorrow. Our mission is to connect passionate educators with institutions that value their impact.</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="prose prose-slate max-w-none">
          <h2>Who We Are</h2>
          <p>EdAssist is India's premium recruitment platform exclusively focused on the education sector. From K–12 schools to higher education and edtech startups, we help institutions hire educators, administrators, and specialists who shape minds and build futures.</p>
          <p>We combine education industry expertise with smart recruitment tools to deliver a seamless experience for both employers and job seekers.</p>

          <h2>What We Do</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 my-8">
          {[
            { icon: Search, title: 'Job Discovery for Educators', desc: 'We connect teachers, counselors, academic leaders, and support staff with verified opportunities in schools, universities, and online education platforms.' },
            { icon: ClipboardList, title: 'Simplified Hiring for Institutions', desc: 'Institutions can post jobs, screen applicants, and manage hiring all in one place — designed to reduce time-to-hire and improve fit.' },
            { icon: Rocket, title: 'Growth Tools for Career Seekers', desc: 'EdAssist offers more than listings — we support educator growth with resume tools, interview prep, and curated career advice.' },
          ].map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-slate-200 p-6 hover:shadow-md transition-shadow">
              <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center mb-4">
                <item.icon className="w-5 h-5 text-indigo-600" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit' }}>{item.title}</h3>
              <p className="text-sm text-slate-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="prose prose-slate max-w-none">
          <h2>Why Choose EdAssist?</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 my-8">
          {[
            { icon: Users, title: 'Education-Only Platform', desc: 'We specialize in what others generalize. Our deep sector knowledge ensures better matches and more relevant opportunities.' },
            { icon: Zap, title: 'Smart, Fast, Reliable', desc: 'From AI-based applicant matching to real-time updates, our tech makes recruitment efficient and stress-free.' },
            { icon: Shield, title: 'Trusted and Transparent', desc: 'Every job is verified. Every candidate is respected. Every interaction is human-first.' },
          ].map((item, i) => (
            <div key={i} className="bg-slate-50 rounded-xl border border-slate-200 p-6">
              <div className="w-10 h-10 rounded-lg bg-white border border-slate-200 flex items-center justify-center mb-4">
                <item.icon className="w-5 h-5 text-indigo-600" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit' }}>{item.title}</h3>
              <p className="text-sm text-slate-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="prose prose-slate max-w-none">
          <h2>Our Vision</h2>
          <p>To be India's most trusted partner in educational recruitment — enabling learning institutions to thrive by hiring right, and empowering educators to grow their careers with purpose.</p>

          <h2>Contact Us</h2>
          <p><strong>EdAssist</strong><br />(HRassistance India Consultancy LLP)<br />Email: <a href="mailto:info@edassist.co.in" className="text-indigo-600">info@edassist.co.in</a><br />Address: 205A, Town Square, Viman Nagar, Pune-411014, India</p>
        </div>
      </div>
    </div>
  </PublicLayout>
);

export default AboutUsPage;
